import { render, staticRenderFns } from "./ClipFolder.vue?vue&type=template&id=1f3ed5b6"
import script from "./ClipFolder.vue?vue&type=script&lang=js"
export * from "./ClipFolder.vue?vue&type=script&lang=js"
import style0 from "./ClipFolder.vue?vue&type=style&index=0&id=1f3ed5b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
